module.exports = __webpack_public_path__ + "static/img/yun01_1.085497e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_1.jpg
// module id = Ah1x
// module chunks = 1